import { Component, OnInit } from '@angular/core';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

@Component({
  selector: 'app-otp-problem',
  templateUrl: './otp-problem.component.html',
  styleUrls: ['./otp-problem.component.scss'],
})
export class OtpProblemComponent implements OnInit {

  infoTable: any;
  displayedColumns: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private parametersService: ParametersService,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    this.infoTable = this.parametersService.getSetting(OpEnum.INFO_TABLE);
    this.displayedColumns = this.infoTable.title.map(e => e.key);
  }

  next() {
    this.navigationService.nextStep('200');
  }
}
